"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentEditorInput = void 0;
const React = require("react");
const RichContentEditor_1 = require("../../atoms/RichContentEditor");
/**
 * WYSIWYG editor
 *
 * Responds to changes in value, and calls onInputChange with a debounce if any changes occur in the editor.
 *
 * @link for more info regarding the redactorConfig, see https://imperavi.com/redactor/docs/settings
 */
const RichContentEditorInput = props => {
    return (React.createElement("div", { "data-test": "editor" },
        React.createElement(RichContentEditor_1.RichContentEditor, Object.assign({}, props))));
};
exports.RichContentEditorInput = RichContentEditorInput;
//# sourceMappingURL=index.js.map